"use client";

import React, { memo, useMemo } from "react";

import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";

import { h_400_14_normal_28 } from "@/styles/fontStyles";


import { FilterElementList } from "../companies/companiesList/companiesListComponents/tablesTools/innerComponents/filtersBlock/innerComponents/FiltersPanel";

const Filter = ({ item }) => {
  const filteredSubItems = useMemo(() => {
    return (item?.subItem || []).filter(
      (el) => el?.data?.subItems?.length > 0 || el.scope
    );
  }, [item?.subItem]);
  return (
    <Box>
      <Flex
        w="100%"
        alignItems={"center"}
        py="4px"
        borderBottom={"1px solid #7E869E"}
        mb={"18px"}
        mt={"24px"}
        zIndex={1000}
      >
        <Box pb={"7px"}> {item?.icon}</Box>
        <Text ml={"5px"} {...h_400_14_normal_28} color={"red"}>
          {item?.name}
        </Text>
      </Flex>
      {filteredSubItems.map((subItem) => (
        <SubItem
          key={"subItem" + subItem?.name}
          levelOne={item?.name}
          subItem={subItem}
        />
      ))}
    </Box>
  );
};

export default memo(Filter);

function SubItem({ subItem }) {
  return (
    <AccordionItem
      border={"none"}
      _focus={{ background: "none" }}
      _hover={{ background: "none" }}
      mt={"8px"}
    >
      <AccordionButton
        _focus={{ background: "none" }}
        _hover={{ background: "none" }}
        p={0}
        mb={"8px"}
      >
        <Flex justifyContent="start" w="100%" alignItems={"center"}>
          <Text textAlign={"start"} {...h_400_14_normal_28}>
            {subItem.name}
          </Text>
          <AccordionIcon />
        </Flex>
      </AccordionButton>
      <Box sx={{ ".chakra-collapse": { overflow: "unset" } }}>
        <AccordionPanel {...{ h: "100%", p: "0" }}>
          <FilterElementList {...{ el: subItem, isBlock: true }} />
        </AccordionPanel>
      </Box>
    </AccordionItem>
  );
}
